import { SortOptions } from '@/shared/types/common';

export const sessionsSortOptions: SortOptions[] = [
  {
    id: '1',
    title: 'Start Date',
    options: [
      { label: 'Newest', value: 'scheduledAt:desc' },
      { label: 'Oldest', value: 'scheduledAt:asc' },
    ],
  },
  {
    id: '2',
    title: 'Duration',
    options: [
      { label: 'Long to Short', value: 'duration:desc' },
      { label: 'Short to Long', value: 'duration:asc' },
    ],
  },
];
